import React, { Component } from "react";
import { deleteCountry, getAllCountries, getCountries } from "../../Path/Path";
import { withRouter } from "../../components/withRouter";
import MyInput from "../../components/MyInput";
import { toast } from 'react-toastify';
import { PaginatedItems } from "../../components/Paginated";
import { Autocomplete, TextField } from "@mui/material";
import Loader from "../../components/Loader";
import { PaginatedItemsOffline } from "../../components/PaginatedOffline";
import AlertDialog from "../../components/AlertDialog";
import { formatItem } from "../common/FormatItems";
class Countries extends Component {
    state = {

        countryData: [],
        countryName: "",
        countryCode: "",
        paginationData: {},
        tableFilter: [],
        itemsPerPage: 10,
        loading: false,
        deleteModal: null,
        allCountries: [],
    }
    async componentDidMount() {
        this.countryHandler()
        const data = await getAllCountries()
        this.setState({allCountries: data.data?.data})
    }
    handler = () => {
        this.props.history("/add-country")
    }


    countryHandler = async (pageNumber = 1) => {
        try{
        this.setState({ loading: true })
        const params ={
            pageNo : pageNumber,
            name: this.state.countryName,
            code: this.state.countryCode
        }
        const data = await getCountries(params);
        this.setState({ countryData: data, tableFilter: data?.data?.data, paginationData: data.data })
        this.setState({ loading: false })
         } 
         catch (error) {
            this.setState({loading: false})
            toast.error("Something went wrong")
        }
    }
    deleteHandler = async (id) => {
        try {
            await deleteCountry(id);
            this.countryHandler();
            toast.success("Country deleted successfully")
            this.setState({deleteModal: null})
        } catch (err) {
            toast.warn(err.message)

        }
    }
    editHandler = (item) => {
        this.props.history("/add-country", { state: { item } })
    }

    render() {
        
        const headers = [
            "Country Name",
            "Country Code",
            "Prefix",
        ]

        const colNames = [
            "name",
            "code",
            "prefix",
        ]

        return (
            <>
            <AlertDialog
                    deleteThis="Country"
                    onDeletePress={() => this.deleteHandler(this.state?.deleteModal)}
                    open={this.state.deleteModal ? true : false}
                    handleClose={() => this.setState({ deleteModal: null })}
                />
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div> <p className="stock-count" style={{ fontSize: '25px', margin: 0 }}>Countries Info</p>
                            <h1 style={{ color: 'black', fontSize: '15px' }}>{new Date().toLocaleString('hi-IN')} </h1>
                        </div>
                        <button className="run-btn" onClick={() => this.handler()}><p className="add-text">Add Country</p></button>
                    </div>
                    <div className="store-bottom">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: "left-align", width: "720px", gap: "10px" }}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                freeSolo= {false}
                                size={'small'}
                                options={this.state.allCountries?.map((item => item?.name)).reduce((noDupArr, entry) => {
                                    if (noDupArr?.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, []).filter((item => item !== null && item !== undefined))}
                                onChange={(e, v) => this.setState({ countryName: v === null ? '' : v })}
                                onInputChange={(e) => {
                                    this.setState({ countryName: e.target.value ? e.target.value : "" });
                                }}
                                sx={{ width: 235 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Country Name" />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                freeSolo={false}
                                size={'small'}
                                options={this.state.allCountries?.map((item => item?.code)).reduce((noDupArr, entry) => {
                                    if (noDupArr?.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, []).filter((item => item !== null && item !== undefined))}
                                onChange={(e, v) => this.setState({ countryCode: v === null ? '' : v })}
                                onInputChange={(e) =>{
                                    this.setState({countryCode : e.target.value ? e.target.value : "" })
                                }}
                                sx={{ width: 235 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Country Code" />}
                            />
                        </div>
                        <button className="run-btn" onClick={() => this.countryHandler()}><p className="run-text">Search</p></button>
                    </div>
                    <div style={{ paddingTop: "2%" }}>
                        <PaginatedItems 
                        pageCountNew={this.state.paginationData?.next + this.state.paginationData?.previous + 1}
                        getData={(pageNumber) => this.countryHandler(pageNumber)}
                        totalLength={this.state.paginationData?.next}
                        headers={headers} 
                        colNames={colNames} 
                        forcePage={this.state.paginationData?.previous || 0}
                        editHandler={(item) => this.editHandler(item)} 
                        deleteHandler={(item) => this.setState({deleteModal: item._id})} 
                        Action
                        itemsPerPage={this.state.itemsPerPage} 
                        data={this.state.tableFilter.map((item) =>{
                            return formatItem(item)
                        })} />
                    </div>
                </div>
            </>
        )
    }
}
export default withRouter(Countries);
